app.service('LegalAgreementService', [
    '$rootScope',
    '$sce',
    'LegalAgreementAPI',
    'Session',
    '$modal',
    '$window',
    '$sanitize',
    function ($rootScope, $sce, LegalAgreementAPI, Session, $modal, $window, $sanitize) {
        let queue = [];
        let modalInstance = null;

        /**
         * Fetch pending agreements from the API and enqueue them.
         * Call this method right after the user successfully logs in.
         */
        this.checkPendingAgreements = () => {
            // Already showing one: re-entering the welcome page must not stack a second modal on it.
            if (modalInstance) {
                return;
            }
            LegalAgreementAPI.getPendingDocuments()
                .then(resp => {
                    queue = resp.data || [];

                    // Sort oldest first so they accept historical updates in chronological order
                    queue.sort((a, b) => Date.parse(a.date_created || 0) - Date.parse(b.date_created || 0));

                    this._showNext();
                })
                .catch(err => console.error('Error fetching pending legal agreements:', err && err.status));
        };

        /**
         * Dequeue the next agreement and render the modal.
         */
        this._showNext = () => {
            if (!queue.length) {
                // Queue is empty; user has accepted everything.
                $rootScope.$broadcast('legalAgreementsCleared');
                return;
            }

            const agreement = queue.shift();

            // Sanitised before it is trusted, so markup in an uploaded document cannot run script here.
            agreement.trustedHtmlContent = $sce.trustAsHtml($sanitize(agreement.escaped_html_content || ''));

            // Create an isolated scope for the modal
            const modalScope = $rootScope.$new();
            modalScope.pendingAgreement = agreement;
            modalScope.isAccepting = false;

            // Check have scrolled to bottom.
            modalScope.hasScrolledToBottom = false;
            modalScope.onScrolledToBottom = () => {
                if (!modalScope.hasScrolledToBottom) {
                    modalScope.hasScrolledToBottom = true;
                }
            };

            // Handle Accept
            modalScope.acceptAgreement = () => {
                modalScope.isAccepting = true;

                LegalAgreementAPI.acceptDocument(agreement.document_id)
                    .then(() => {
                        // Success: hide this modal and check if there are more in the queue
                        modalInstance.hide();
                        modalScope.$destroy();
                        modalInstance = null;
                        this._showNext();
                    })
                    .catch(err => {
                        console.error('Error accepting legal agreement:', err && err.status);
                        modalScope.isAccepting = false;
                        alert("There was an error saving your agreement. Please try again.");
                    });
            };

            // Handle Reject / Cancel
            modalScope.rejectAgreement = () => {
                console.warn("User rejected mandatory terms. Logging out.");
                modalInstance.hide();
                modalScope.$destroy();
                modalInstance = null;

                // TODO: Replace with your actual application logout/auth clearing logic
                $window.location.href = '/login';
            };

            // Launch the modal
            modalInstance = $modal({
                scope: modalScope,
                templateUrl: 'app/src/views/templates/modal.legal-agreement.tpl.html',
                show: true,
                backdrop: 'static', // Prevent clicking outside to close
                keyboard: false     // Prevent ESC key from closing
            });
        };
    }
]);